import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import SalesOrderInformationView from "./single";
import SalesOrdersListView from "./list";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const SalesOrderViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.sales.salesOrderInformation &&
                <Route path={routes.customer.sales.salesOrder.single} exact>
                    <SalesOrderInformationView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.salesOrdersList &&
                <Route path={[routes.customer.sales.salesOrder.base, routes.sales.salesOrder]}
                       exact>
                    <SalesOrdersListView/>
                </Route>
            }
            <Redirect to={routes.sales.salesOrder.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default SalesOrderViews;
